enum TabTypes {
  Cleared = "cleared",
  Pending = "pending",
  Cancelled = "cancelled"
}

export default TabTypes
